import { render, staticRenderFns } from "./phoneTriage.vue?vue&type=template&id=8396e8fa&scoped=true&"
import script from "./phoneTriage.vue?vue&type=script&lang=js&"
export * from "./phoneTriage.vue?vue&type=script&lang=js&"
import style0 from "./phoneTriage.vue?vue&type=style&index=0&id=8396e8fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8396e8fa",
  null
  
)

export default component.exports